<template xmlns="http://www.w3.org/1999/html">
  <el-dialog
    :visible.sync = 'isVisible'
    width="1000px"
    append-to-body
    :close-on-click-modal="false"
  >
    <div v-html="stateInfo">

    </div>
  </el-dialog>
</template>
<script>

import {request} from "@/util/request";

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '系统声明'
    }
  },
  data() {
    return {
      infos: {},
      statementTitle: '系统声明',
      stateInfo: null
    }
  },
  computed: {
    // 弹窗是否可见
    isVisible: {
      get() {
        return this.dialogVisible
      },
      set() {
        this.close()
        this.reset()
      }
    },
  },
  created() {
    this.infos = this.$route.params.info
    this.infos = JSON.parse(sessionStorage.getItem("user"))
    this.getStateInfo()
  },
  mounted() {},
  methods: {
    getStateInfo() {
      request({
        method: 'get',
        url: '/index/statementInfo'
      }).then(res=>{
        if (res.code == 0) {
          this.stateInfo = res.data.student;
        }
      })
    },
    close() {
      this.$emit('update:dialogVisible', false)
    },
  }
}
</script>

<style>
.sys-statement {
  text-indent: 2em; /* 设置首行缩进为2em */
}
</style>
